export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/background-050149d63fbb9ee81f9b8898ce1c4197.png";